(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shpflt-localization-popup"] && !Shopify.designMode) return;
  try {
    
  /**
   * Shpflt Localization Popup JavaScript (updated)
   * - Editor: only shows when this section/block is selected
   * - Uses editor events' detail.sectionId / blockId to match
   */

  class ShpfltLocalizationPopup extends HTMLElement {
    constructor() {
      super();
      if (this.hasAttribute('data-initialized')) return;
      this.setAttribute('data-initialized', 'true');

      // Bind methods
      this.init = this.init.bind(this);
      this.openCountrySelector = this.openCountrySelector.bind(this);
      this.openLanguageSelector = this.openLanguageSelector.bind(this);
      this.hideCountryPanel = this.hideCountryPanel.bind(this);
      this.hideLanguagePanel = this.hideLanguagePanel.bind(this);
      this.closeCountrySelector = this.closeCountrySelector.bind(this);
      this.closeLanguageSelector = this.closeLanguageSelector.bind(this);
      this.onCountryItemClick = this.onCountryItemClick.bind(this);
      this.onLanguageItemClick = this.onLanguageItemClick.bind(this);
      this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
      this.onFormSubmit = this.onFormSubmit.bind(this);
      this.filterCountries = this.filterCountries.bind(this);
      this.clearCountrySearch = this.clearCountrySearch.bind(this);
      this.handleSearchKeydown = this.handleSearchKeydown.bind(this);
      this.initPopupTrigger = this.initPopupTrigger.bind(this);
      this.shouldShowPopup = this.shouldShowPopup.bind(this);
      this.showPopup = this.showPopup.bind(this);
      this.hidePopup = this.hidePopup.bind(this);
      this.setupExitIntent = this.setupExitIntent.bind(this);
      this.handleSectionSelect = this.handleSectionSelect.bind(this);
      this.handleSectionDeselect = this.handleSectionDeselect.bind(this);
      this.disconnectedCallback = this.disconnectedCallback.bind(this);

      // Cache elements
      this.elements = {
        countryButton: this.querySelector('[aria-controls*="country"]'),
        countryList: this.querySelector('[id*="country-list"]'),
        countrySearchContainer: this.querySelector('.shpflt-localization-popup__search-container'),
        countrySearchInput: this.querySelector('.shpflt-localization-popup__search-input'),
        countrySearchClear: this.querySelector('.shpflt-localization-popup__search-clear'),
        languageButton: this.querySelector('[aria-controls*="language"]'),
        languageList: this.querySelector('[id*="language-list"]'),
        countryInput: this.querySelector('input[name="country_code"]'),
        languageInput: this.querySelector('input[name="language_code"]'),
        form: this.querySelector('form'),
        submitButton: this.querySelector('.shpflt-localization-popup__submit'),
        closeButton: this.querySelector('.js-close-modal'),
      };

      // Trigger config
      this.trigger = this.dataset.trigger;
      this.delay = parseInt(this.dataset.delay) * 1000;
      this.dismissDays = parseInt(this.dataset.dismissDays);
      this.showOnMobile = this.dataset.showOnMobile === 'true';
      this.exitIntentHandler = null;
      this.triggerTimeout = null;

      // Determine enclosing section id (strip prefix)
      const sectionEl =
        this.closest('.shopify-section') || this.closest('section[id^="shopify-section-"]') || this.closest('section');
      this.sectionId = (sectionEl?.id || '').replace('shopify-section-', '').trim();

      this.init();
    }

    /** Initialize popup logic */
    async init() {
      // In theme editor: set up listeners, do not auto-show
      if (window.Shopify?.designMode) {
        this.initPopupTrigger();
      } else {
        // Storefront
        if (!this.shouldShowPopup()) return;
        const shouldShow = await this.detectOptimalLocalization();
        if (!shouldShow) return;
        this.initPopupTrigger();
      }

      // Event handlers
      if (this.elements.countryButton && this.elements.countryList) {
        this.elements.countryButton.addEventListener('click', this.openCountrySelector);
        this.elements.countryButton.addEventListener('focusout', this.closeCountrySelector);

        if (this.elements.countrySearchInput) {
          this.elements.countrySearchInput.addEventListener('input', this.filterCountries);
          this.elements.countrySearchInput.addEventListener('keydown', this.handleSearchKeydown);
        }

        if (this.elements.countrySearchClear) {
          this.elements.countrySearchClear.addEventListener('click', this.clearCountrySearch);
        }

        this.elements.countryList.querySelectorAll('[data-value]').forEach((item) => {
          item.addEventListener('click', this.onCountryItemClick);
        });
      }

      if (this.elements.languageButton && this.elements.languageList) {
        this.elements.languageButton.addEventListener('click', this.openLanguageSelector);
        this.elements.languageButton.addEventListener('focusout', this.closeLanguageSelector);

        this.elements.languageList.querySelectorAll('[data-value]').forEach((item) => {
          item.addEventListener('click', this.onLanguageItemClick);
        });
      }

      this.addEventListener('keyup', this.onContainerKeyUp);

      if (this.elements.form) {
        this.elements.form.addEventListener('submit', this.onFormSubmit);
      }

      if (this.elements.closeButton) {
        this.elements.closeButton.addEventListener('click', this.hidePopup);
      }

      this.addEventListener('click', (e) => {
        if (e.target === this) this.hidePopup();
      });
    }

    // -------------------------
    // Selectors & Panels
    // -------------------------
    hideCountryPanel() {
      if (this.elements.countryButton && this.elements.countryList) {
        this.elements.countryButton.setAttribute('aria-expanded', 'false');
        this.elements.countryList.setAttribute('hidden', true);
        document.body.style.overflow = '';
      }
    }

    hideLanguagePanel() {
      if (this.elements.languageButton && this.elements.languageList) {
        this.elements.languageButton.setAttribute('aria-expanded', 'false');
        this.elements.languageList.setAttribute('hidden', true);
        document.body.style.overflow = '';
      }
    }

    openCountrySelector() {
      this.hideLanguagePanel();

      if (this.elements.countryButton && this.elements.countryList) {
        this.elements.countryList.toggleAttribute('hidden');
        const isOpen = !this.elements.countryList.hasAttribute('hidden');
        this.elements.countryButton.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          if (this.elements.countrySearchContainer) this.elements.countrySearchContainer.removeAttribute('hidden');
          if (this.elements.countrySearchInput) this.elements.countrySearchInput.focus();
          document.body.style.overflow = 'hidden';
        } else {
          this.clearCountrySearch();
          if (this.elements.countrySearchContainer) this.elements.countrySearchContainer.setAttribute('hidden', '');
          document.body.style.overflow = '';
        }
      }
    }

    openLanguageSelector() {
      this.hideCountryPanel();

      if (this.elements.languageButton && this.elements.languageList) {
        this.elements.languageList.toggleAttribute('hidden');
        const isOpen = !this.elements.languageList.hasAttribute('hidden');
        this.elements.languageButton.setAttribute('aria-expanded', String(isOpen));
        document.body.style.overflow = isOpen ? 'hidden' : '';
      }
    }

    closeCountrySelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) this.hideCountryPanel();
    }

    closeLanguageSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) this.hideLanguagePanel();
    }

    onCountryItemClick(event) {
      event.preventDefault();

      const selectedValue = event.currentTarget.dataset.value;
      const selectedText = event.currentTarget.textContent.trim();

      if (this.elements.countryInput) this.elements.countryInput.value = selectedValue;
      if (this.elements.countryButton) {
        const text = this.elements.countryButton.querySelector('.shpflt-localization-popup__button-text');
        if (text) text.textContent = selectedText;
      }

      this.clearCountrySearch();
      if (this.elements.countrySearchContainer) this.elements.countrySearchContainer.setAttribute('hidden', '');
      this.hideCountryPanel();

      this.querySelectorAll('[id*="country-list"] a').forEach((a) => a.removeAttribute('aria-current'));
      event.currentTarget.setAttribute('aria-current', 'true');
    }

    onLanguageItemClick(event) {
      event.preventDefault();

      const selectedValue = event.currentTarget.dataset.value;
      const selectedText = event.currentTarget.textContent.trim();

      if (this.elements.languageInput) this.elements.languageInput.value = selectedValue;
      if (this.elements.languageButton) {
        const text = this.elements.languageButton.querySelector('.shpflt-localization-popup__button-text');
        if (text) text.textContent = selectedText;
      }

      this.hideLanguagePanel();

      this.querySelectorAll('[id*="language-list"] a').forEach((a) => a.removeAttribute('aria-current'));
      event.currentTarget.setAttribute('aria-current', 'true');
    }

    onContainerKeyUp(event) {
      if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
      this.hideCountryPanel();
      this.hideLanguagePanel();
    }

    async onFormSubmit(event) {
      event.preventDefault();
      const countryCode = this.elements.countryInput?.value;
      const languageCode = this.elements.languageInput?.value;
      if (!countryCode) return;

      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + (Number.isFinite(this.dismissDays) ? this.dismissDays : 7));

      document.cookie = `shpflt_country=${countryCode}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
      if (languageCode) {
        document.cookie = `shpflt_language=${languageCode}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
      }
      document.cookie = `shpflt_popup_dismissed=${Date.now()}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;

      this.hidePopup();
      await this.updateLocalization({ country: countryCode, language: languageCode });
    }

    async updateLocalization({ country, language }) {
      try {
        const formId = crypto.randomUUID();
        const formHtml = `
        <form id="${formId}" action="/localization" method="POST" hidden>
          <input name="_method" value="PUT" />
          <input name="country_code" value="${country}" />
          ${language ? `<input name="language_code" value="${language}" />` : ''}
        </form>
      `;
        document.body.insertAdjacentHTML('beforeend', formHtml);
        document.getElementById(formId).submit();
      } catch (error) {
        console.error('Error updating localization:', error);
        if (this.elements.form) this.elements.form.submit();
      }
    }

    // -------------------------
    // Search functionality
    // -------------------------
    filterCountries(event) {
      const searchTerm = (event.target.value || '').toLowerCase();
      if (!this.elements.countryList) return;

      const items = this.elements.countryList.querySelectorAll('.shpflt-localization-popup__item');
      let hasVisibleItems = false;

      items.forEach((item) => {
        const match = (item.dataset.search || '').includes(searchTerm);
        item.toggleAttribute('hidden', !match);
        if (match) hasVisibleItems = true;
      });

      const noResults = this.querySelector('.shpflt-localization-popup__no-results');
      if (noResults) {
        if (searchTerm && !hasVisibleItems) noResults.removeAttribute('hidden');
        else noResults.setAttribute('hidden', '');
      }

      if (this.elements.countrySearchClear) {
        this.elements.countrySearchClear.style.display = searchTerm ? 'block' : 'none';
      }
    }

    clearCountrySearch() {
      if (!this.elements) return;
      const input = this.elements.countrySearchInput;
      const list = this.elements.countryList;

      if (input) input.value = '';
      if (list) {
        list.querySelectorAll('.shpflt-localization-popup__item').forEach((i) => i.removeAttribute('hidden'));
      }
      const noResults = this.querySelector('.shpflt-localization-popup__no-results');
      if (noResults) noResults.setAttribute('hidden', '');
      if (this.elements.countrySearchClear) this.elements.countrySearchClear.style.display = 'none';
    }

    handleSearchKeydown(event) {
      if (!this.elements.countryList) return;
      const items = Array.from(
        this.elements.countryList.querySelectorAll('.shpflt-localization-popup__item:not([hidden])')
      );

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const dir = event.key === 'ArrowDown' ? 1 : -1;
        const currentIndex = items.findIndex((i) =>
          i.classList.contains('shpflt-localization-popup__item--highlighted')
        );
        items.forEach((i) => i.classList.remove('shpflt-localization-popup__item--highlighted'));
        const newIndex = items.length ? ((currentIndex + dir + items.length) * 1) % items.length : -1;
        if (newIndex >= 0 && items[newIndex]) {
          items[newIndex].classList.add('shpflt-localization-popup__item--highlighted');
          items[newIndex].scrollIntoView({ block: 'nearest' });
        }
      } else if (event.key === 'Enter') {
        event.preventDefault();
        const highlighted = this.elements.countryList.querySelector('.shpflt-localization-popup__item--highlighted');
        if (highlighted) highlighted.querySelector('a')?.click();
      } else if (event.key === 'Escape') {
        this.hideCountryPanel();
      }
    }

    // -------------------------
    // Localization Discovery
    // -------------------------
    async detectOptimalLocalization() {
      try {
        const response = await fetch(
          window.Shopify.routes.root +
            'browsing_context_suggestions.json' +
            '?country[enabled]=true' +
            `&country[exclude]=${window.Shopify.country}` +
            '&language[enabled]=true' +
            `&language[exclude]=${window.Shopify.language}`
        );
        if (!response.ok) return false;
        const data = await response.json();

        if (data.suggestions && data.suggestions.length > 0) {
          const suggestion = data.suggestions[0];
          if (suggestion.confidence >= 0.8) {
            const suggestedCountry = suggestion.parts.country?.handle;
            const suggestedLanguage = suggestion.parts.language?.handle;
            const currentCountry = window.Shopify.country;
            const currentLanguage = window.Shopify.language;
            const countryChanged = suggestedCountry && suggestedCountry !== currentCountry;
            let languageChanged = false;
            if (suggestedLanguage && currentLanguage) languageChanged = suggestedLanguage !== currentLanguage;

            if (countryChanged || languageChanged) {
              this.suggestedCountry = suggestedCountry;
              this.suggestedLanguage = suggestedLanguage;
              this.detectedCountry = data.detected_values?.country?.name;
              this.preselectSuggestedValues();
              this.showDetectionMessage();
              return true;
            }
          }
        }
        return false;
      } catch (error) {
        console.warn('Error detecting optimal localization:', error);
        return false;
      }
    }

    preselectSuggestedValues() {
      if (this.suggestedCountry && this.elements.countryInput) {
        this.elements.countryInput.value = this.suggestedCountry;
        const countryButton = this.elements.countryButton;
        if (countryButton) {
          const buttonText = countryButton.querySelector('.shpflt-localization-popup__button-text');
          if (buttonText) {
            const countryItem = this.querySelector(`[data-value="${this.suggestedCountry}"]`);
            if (countryItem) buttonText.textContent = countryItem.textContent.trim();
          }
        }
      }
      if (this.suggestedLanguage && this.elements.languageInput) {
        this.elements.languageInput.value = this.suggestedLanguage;
        const languageButton = this.elements.languageButton;
        if (languageButton) {
          const buttonText = languageButton.querySelector('.shpflt-localization-popup__button-text');
          if (buttonText) {
            const languageItem = this.querySelector(`[data-value="${this.suggestedLanguage}"]`);
            if (languageItem) buttonText.textContent = languageItem.textContent.trim();
          }
        }
      }
    }

    showDetectionMessage() {
      const detectionMessage = this.querySelector('.shpflt-localization-popup__detection-message');
      const detectedLocation = this.querySelector('.shpflt-localization-popup__detected-location');
      if (detectionMessage && detectedLocation && this.detectedCountry) {
        detectedLocation.textContent = this.detectedCountry;
        detectionMessage.style.display = 'block';
      }
    }

    // -------------------------
    // Popup Logic
    // -------------------------
    shouldShowPopup() {
      // Always allow editor (actual showing controlled by selection)
      if (window.Shopify?.designMode) return true;

      const dismissedCookie = this.getCookie('shpflt_popup_dismissed');
      if (dismissedCookie) {
        const dismissedTime = parseInt(dismissedCookie, 10);
        const days = Number.isFinite(this.dismissDays) ? this.dismissDays : 7;
        const ms = days * 24 * 60 * 60 * 1000;
        if (Date.now() - dismissedTime < ms) return false;
      }
      return true;
    }

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    initPopupTrigger() {
      // Start hidden
      this.classList.add('invisible');
      this.style.visibility = 'hidden';

      // Editor: listen for select/deselect on this section (or block)
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:section:deselect', this.handleSectionDeselect);
        document.addEventListener('shopify:block:select', this.handleSectionSelect);
        document.addEventListener('shopify:block:deselect', this.handleSectionDeselect);
        return;
      }

      // Storefront triggers
      if (!this.shouldShowPopup()) return;
      if (!this.showOnMobile && window.innerWidth < 768) return;

      if (this.trigger === 'delay') {
        this.triggerTimeout = setTimeout(this.showPopup, this.delay);
      } else if (this.trigger === 'exit') {
        this.setupExitIntent();
      }
    }

    showPopup() {
      this.classList.remove('invisible');
      this.style.visibility = 'visible';
      document.body.style.overflow = 'hidden';
    }

    hidePopup() {
      this.classList.add('invisible');
      this.style.visibility = 'hidden';
      document.body.style.overflow = '';

      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + (Number.isFinite(this.dismissDays) ? this.dismissDays : 7));
      document.cookie = `shpflt_popup_dismissed=${Date.now()}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
    }

    setupExitIntent() {
      let triggered = false;
      this.exitIntentHandler = (e) => {
        if (!triggered && e.clientY <= 0) {
          triggered = true;
          this.showPopup();
        }
      };
      document.addEventListener('mouseleave', this.exitIntentHandler);
    }

    handleSectionSelect(event) {
      const incomingId = event?.detail?.sectionId || event?.detail?.blockId;
      if (!incomingId || !this.sectionId) return;
      if (incomingId === this.sectionId) this.showPopup();
    }

    handleSectionDeselect(event) {
      const incomingId = event?.detail?.sectionId || event?.detail?.blockId;
      if (!incomingId || !this.sectionId) return;
      if (incomingId === this.sectionId) this.hidePopup();
    }

    disconnectedCallback() {
      if (this.triggerTimeout) clearTimeout(this.triggerTimeout);
      if (this.exitIntentHandler) document.removeEventListener('mouseleave', this.exitIntentHandler);
      if (window.Shopify?.designMode) {
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.handleSectionDeselect);
        document.removeEventListener('shopify:block:select', this.handleSectionSelect);
        document.removeEventListener('shopify:block:deselect', this.handleSectionDeselect);
      }
      document.body.style.overflow = '';
    }
  }

  customElements.define('shpflt-localization-popup', ShpfltLocalizationPopup);

  } catch(e) { console.error(e); }
})();
})();
